var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TwPopup',{class:_vm.isPositionTop ? 'position-top' : '',attrs:{"title":'设置' + ((_vm.activeCarItem && _vm.activeCarItem.remark) || '自定义') + '的地点',"open":_vm.showPopup,"showFooter":false},on:{"change":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleChange).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticClass:"container"},[_c('PlaceSelectPage',{attrs:{"pageFrom":"popup","selectType":_vm.selectType,"activeCarItem":_vm.activeCarItem,"defaultCityData":_vm.defaultCityData},on:{"afterSetCommolyUsed":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.$emit('afterSetCommolyUsed')
},"focus":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(function (show) { return (_vm.isPositionTop = show); }).apply(void 0, arguments)
}}})],1)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }